document.addEventListener('DOMContentLoaded', () => {
  const LOCAL_STORAGE_KEY = 'aquas-wishlist';

  function initWishlist() {
    const wishlist = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '[]');

    // Handle product card wishlist buttons
    document.querySelectorAll('.product-card__wishlist').forEach((btn) => {
      const handle = btn.dataset.productHandle;
      if (wishlist.includes(handle)) {
        btn.classList.add('active');
        // Fill the heart
        const path = btn.querySelector('path');
        if (path) path.setAttribute('fill', 'currentColor');
      }

      // Remove old listeners to avoid duplicates if re-init
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation(); // prevent card click
        toggleWishlist(newBtn, handle);
      });
    });

    // Handle product page wishlist buttons
    document.querySelectorAll('.product-form__wishlist-button').forEach((btn) => {
      const handle = btn.dataset.productHandle;
      if (wishlist.includes(handle)) {
        btn.classList.add('is-wishlisted');
        const icon = btn.querySelector('.wishlist-icon');
        if (icon) icon.textContent = '♥';
      }

      // Remove old listeners to avoid duplicates if re-init
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        toggleWishlistProductPage(newBtn, handle);
      });
    });
  }

  function toggleWishlist(btn, handle) {
    let wishlist = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '[]');
    const index = wishlist.indexOf(handle);

    if (index === -1) {
      wishlist.push(handle);
      btn.classList.add('active');
      const path = btn.querySelector('path');
      if (path) path.setAttribute('fill', 'currentColor');
    } else {
      wishlist.splice(index, 1);
      btn.classList.remove('active');
      const path = btn.querySelector('path');
      if (path) path.setAttribute('fill', 'none');
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(wishlist));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: wishlist.length } }));
  }

  function toggleWishlistProductPage(btn, handle) {
    let wishlist = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '[]');
    const index = wishlist.indexOf(handle);
    const icon = btn.querySelector('.wishlist-icon');

    if (index === -1) {
      wishlist.push(handle);
      btn.classList.add('is-wishlisted');
      if (icon) icon.textContent = '♥';
    } else {
      wishlist.splice(index, 1);
      btn.classList.remove('is-wishlisted');
      if (icon) icon.textContent = '♡';
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(wishlist));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: wishlist.length } }));
  }

  // Init on load
  initWishlist();

  // Re-init when sections re-render (e.g. filters)
  document.addEventListener('shopify:section:load', initWishlist);
});
